import i18next from 'i18next'

i18next.addResources('es', 'succesModal', {
  somethingWrong: '¡Bien!',
  userSuccess: 'El usuario fue creado correctamente.'
})
